module.exports = __webpack_public_path__ + "img/SR.a871f205.svg";